import { render, staticRenderFns } from "./button.component.vue?vue&type=template&id=371465f0&scoped=true&"
import script from "./button.component.vue?vue&type=script&lang=ts&"
export * from "./button.component.vue?vue&type=script&lang=ts&"
import style0 from "./button.component.vue?vue&type=style&index=0&id=371465f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371465f0",
  null
  
)

export default component.exports